import styled from 'styled-components';

const H4 = styled.h4`
  font-size: 26px;
  margin: 0;
`;

export default H4;
